import { Tooltip } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ItemHeading = ({ title, heading, isOpen, setOpen }) => {
  const { t } = useTranslation();

  const isDisabled = heading === 'Education' || heading === 'Certificate';

  const handleClick = () => {
    if (isDisabled) {
      return;
    }
    setOpen(!isOpen);
  };

  if (isDisabled) {
    return (
      <Tooltip title="Please ask your TM for adding new qualification">
        <div className="flex justify-between cursor-not-allowed bg-gray-200 items-center p-5 opacity-75">
          <h6 className="text-sm font-medium">
            {typeof heading === 'undefined' ? title : t('item.add', { heading })}
          </h6>
        </div>
      </Tooltip>
    );
  }

  return (
    <div
      className={`flex justify-between ${
        !isOpen ? 'bg-gray-200' : ''
      } items-center cursor-pointer p-5`}
      onClick={handleClick}
    >
      <h6 className="text-sm font-medium">
        {typeof heading === 'undefined' ? title : t('item.add', { heading })}
      </h6>
      <i className="material-icons">{isOpen ? 'expand_less' : 'expand_more'}</i>
    </div>
  );
};

export default ItemHeading;
